import Page from '../../layout/Page.ianua';

function MyProfile() {
  return <Page />;
}

export default MyProfile;
